import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'

class ServicesOne extends React.Component {


    shouldComponentUpdate() {
        return false
    }


    render() {
        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #000;            
            background-size: cover;
            padding: 100px 0 50px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 10px 0 20px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 50px 0 50px 0;              
            }
          }
        `

        const ServiceContainer = styled.div`
            background-color: rgba(0,0,0,.9);
            padding: 60px 0;
        `


        const ServiceElement = styled.div`
            margin-bottom: 20px;
            text-align: center;
            padding: 40px;
            border-radius: 20px;
            transition: .2s;
            &:hover {
                background-color: #000;
                box-shadow: 0 28px 60px rgb(193, 235, 24, .4);
                transform: translateY(-10px);
            }
        `
        const ServiceHeading = styled.h3`
            font-size: 30px;
            font-weight: 500;
            font-family: Teko;
            color: #fff;
        `
        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin: auto auto 10px auto;        
         `
        const ServiceIcon = styled.div`
      margin-bottom: 20px;
      img {
        max-height: 70px;
        max-width: 70px;
        width: 100%;
        height: auto;
      }
    `

        const ServiceText = styled.p`
            font-size: 16px;
            font-weight: 300;
            color: #c5c5c5;
            padding-right: 25px;            
        `

        const Text = styled.p`
            font-size: 18px;
            font-weight: 300;
            color: #ffffff;
            padding-bottom: 30px;
            text-align: center;          
        `

        const Color = styled.span`            
            font-weight: bold;
            color: #c1eb18;            
        `
        
        const Heading2 = styled.h2`
            transform: translate(0px, -100px);
            transition: 1s;
            margin-top: 180px;
            font-size: 70px;
            line-height: 90px;
            font-family: Teko;
            font-weight: 500;
            color: #ffffff;
            text-align: center;
            text-transform: uppercase;          
        `
        const ColorV = styled.span`            
            color: #c1eb18;
            font-family: Teko;                        
        `

        return (
            <Section>
                <ServiceContainer>
                    <Container>
                        <Heading2><ColorV>Hosting</ColorV> en  <ColorV>Pereira,</ColorV> Bogotá, <ColorV>Bucaramanga,</ColorV> Barranquilla</Heading2>
                        <Text>
                            ¿Buscas un servicio de hosting confiable y rápido en Colombia? Nuestra infraestructura está diseñada para ofrecerte alto rendimiento
                            y soporte técnico local en las principales ciudades del país. Ya sea que tu empresa esté ubicada en Pereira, Bogotá, Bucaramanga o Barranquilla,
                            contamos con soluciones de hosting optimizados para reducir la latencia, mejorar la velocidad de carga y garantizar la estabilidad de tu sitio web o aplicación.
                        </Text>
                        <Text>
                            Con centros de datos estratégicamente ubicados y tecnologías actualizadas, te ayudamos a mejorar tu presencia digital, el posicionamiento SEO
                            y la experiencia del usuario final. Además, nuestro equipo técnico está disponible 24/7 en español, para brindarte una atención ágil, cercana y efectiva.
                            <b>Impulsa tu negocio con hosting profesional en Colombia, donde la cercanía sí marca la diferencia.</b>
                        </Text>

                        <Row>
                            <Col md={6}>
                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image1} alt="Hosting Web en Pereira con soporte técnico local y baja latencia" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        Hosting Pereira – Velocidad Local
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Hosting optimizado en Pereira con SSD RAID 10 y soporte 24/7. Ideal para negocios en Risaralda, desde $89.997/año.
                                    </ServiceText>
                                </ServiceElement>
                            </Col>
                            <Col md={6}>
                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image2} alt="Hosting en Bogotá con almacenamiento SSD NVMe y uptime garantizado" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        Hosting Bogotá – Potencia para PYMES
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        <Color>Alojamiento web</Color> en Bogotá con SSL gratis y backups diarios. Perfecto para PYMES.
                                    </ServiceText>
                                </ServiceElement>
                            </Col>
                            <Col md={6}>
                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image3} alt="Web Hosting en Bucaramanga con IP colombiana y recursos dedicados" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        Hosting Bucaramanga – Soluciones para Santander
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Hosting en Bucaramanga con soporte 24/7. Ideal para startups y e-commerce.
                                    </ServiceText>
                                </ServiceElement>
                            </Col>
                            <Col md={6}>
                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image4} alt="Hosting en Barranquilla con protección DDoS y soporte 24/7 en español" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        Hosting Barranquilla – Cerca de Ti
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        <Color>Alojamiento web</Color> en Barranquilla con baja latencia y SSD. Perfecto para negocios locales.
                                    </ServiceText>
                                </ServiceElement>
                            </Col>                            
                        </Row>
                    </Container>
                </ServiceContainer>
            </Section>
        )
    }

}

const Iconos = (props) => (
    <StaticQuery
        query={graphql`
        {          
          image1: file(relativePath: { eq: "icons/pereira.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image2: file(relativePath: { eq: "icons/monserrate.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image3: file(relativePath: { eq: "icons/bucaramanga.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image4: file(relativePath: { eq: "icons/barranquilla.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }                 
        }
      `}
        render={(data) => {
            const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
            const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);
            const image3 = getImage(data.image3.childImageSharp.gatsbyImageData);
            const image4 = getImage(data.image4.childImageSharp.gatsbyImageData);            
            return <ServicesOne data={data} image1={image1} image2={image2} image3={image3} image4={image4} {...props} />;
        }}
    />
);

export default Iconos;
